import { useState } from "react";
import { toast } from "sonner";
import { submitContact } from "../lib/api";
import usePageMeta from "../hooks/usePageMeta";

export default function Contact() {
  usePageMeta({title:"Contact",description:"Get in touch with Queen Cleopatra to discuss an erotic hypnosis session, bespoke programme or media enquiry. Discretion guaranteed.",path:"/contact"});
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const update = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await submitContact(form);
      toast.success(res.message || "Message received.");
      setDone(true);
    } catch (err) {
      toast.error("Could not send. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="page-contact">
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="eyebrow mb-5">Correspondence</div>
            <h1 className="font-serif text-5xl md:text-6xl text-cream leading-[1] mb-6">
              Write to <em className="text-gold">Cleopatra</em>.
            </h1>
            <p className="text-cream/70 leading-relaxed mb-6">
              For questions, bespoke requests or press enquiries. Responses are discreet
              and typically arrive within forty-eight hours.
            </p>
            <p className="text-xs uppercase tracking-[0.22em] text-cream/50">London · By Appointment</p>
          </div>

          <div className="md:col-span-7">
            {done ? (
              <div data-testid="contact-success" className="border border-gold/40 p-10 bg-gold/5">
                <h3 className="font-serif text-2xl text-cream mb-3">Thank you.</h3>
                <p className="text-sm text-cream/70">Your message has reached me - I will reply within 48 hours.</p>
              </div>
            ) : (
              <form onSubmit={onSubmit} className="space-y-4 border border-[#c9a04b]/20 bg-charcoalMuted p-6 md:p-8" data-testid="contact-form">
                <Field label="Your name">
                  <input required value={form.name} onChange={update("name")} data-testid="ct-name" className="w-full bg-transparent border border-[#c9a04b]/35 text-cream px-3 py-3 text-sm focus:outline-none focus:border-gold" />
                </Field>
                <Field label="Email">
                  <input required type="email" value={form.email} onChange={update("email")} data-testid="ct-email" className="w-full bg-transparent border border-[#c9a04b]/35 text-cream px-3 py-3 text-sm focus:outline-none focus:border-gold" />
                </Field>
                <Field label="Subject">
                  <input value={form.subject} onChange={update("subject")} data-testid="ct-subject" className="w-full bg-transparent border border-[#c9a04b]/35 text-cream px-3 py-3 text-sm focus:outline-none focus:border-gold" />
                </Field>
                <Field label="Message">
                  <textarea required rows={6} value={form.message} onChange={update("message")} data-testid="ct-message" className="w-full bg-transparent border border-[#c9a04b]/35 text-cream px-3 py-3 text-sm focus:outline-none focus:border-gold" />
                </Field>
                <button type="submit" disabled={loading} className="btn-primary" data-testid="ct-submit">
                  {loading ? "Sending…" : "Send Message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="text-[11px] uppercase tracking-[0.2em] text-cream/55 block mb-2">{label}</label>
      {children}
    </div>
  );
}
